import {
  PatientDocumentControllerApi,
  UploadDocumentDocumentFormatEnum,
  UploadDocumentDocumentTagEnum,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

type Params = {
  patientId: string;
  name: string;
  assigned: boolean; //for provider it should be false
  documentTag: UploadDocumentDocumentTagEnum;
  documentFormat: UploadDocumentDocumentFormatEnum;
  file: File;
  documentDate?: string;
  documentDescription?: string;
  appointmentUuid?: string;
  xTENANTID?: string;
};

/**
 * @author Rajkumar Rathod
 */
export const usePatientDocumentCreate = (isPublic?: boolean) =>
  useMutationWithLoading(async (params: Params) =>
    new PatientDocumentControllerApi(
      isPublic ? undefined : getConfigObject()
    ).uploadDocument(
      params.patientId,
      params.name,
      params.assigned ?? true,
      params.documentTag,
      params.documentFormat,
      params.file,
      params.documentDate,
      params.documentDescription,
      params?.appointmentUuid,
      params.xTENANTID
    )
  );
